import {FilterValue} from './filter-value';
import {BaseFormModel} from '../base-form-model';

export class Filter extends BaseFormModel<Filter> {
    id: number;
    field: string;
    operator: string;
    values: FilterValue[];
    type: string;

    public constructor(jsonInput: any) {
        super(jsonInput);
        Object.assign(this, jsonInput);

        const values = [];
        if (this.values) {
            this.values.forEach(f => {
                values.push(new FilterValue(f));
            });
        }
        this.values = values;
    }
}
